const SEARCH_SERVICE_TYPE = {
  ENTITY: 'entity',
  ENTITY_RECORD: 'entity-record',
};

export default SEARCH_SERVICE_TYPE;
